import { Assets } from './Assets'

export const TspLoans = ({ liabilities, handleOnClick }) => {
  const tspLoans = (liabilities || []).filter(
    (option) => option.subType === TspLoans.targetCategory
  )
  return (
    <Assets
      assets={tspLoans}
      handleOnClick={handleOnClick}
      category={TspLoans.targetCategory}
    />
  )
}
TspLoans.targetCategory = 'tspLoan'
